import {customLocalStorage} from "../context/customStorage";
export const cleanLocalStorageReferredData = () => {
  customLocalStorage.removeItem("wiseInviteCode");
  customLocalStorage.removeItem("referrer");
};
